<template lang="pug">
    div
        v-dialog(
                v-model="showModal"
                width="960"
                persistent
            )

            template(v-slot:activator="{ on }")

                // Open Modal button
                div.text-xs-right
                    button-component.mx-0.my-0(
                        v-on="on"
                        :action="() => showModal = true"
                        color="primary"
                        large
                    ) {{ createEmailButtonText }}

            div.dialogWrapper
                v-form.c-form(autocomplete="off")
                    v-container(fluid grid-list-lg)
                        v-layout.align-center(raw wrap)

                            v-flex(xs6)

                                // Title
                                title-component(:title="title" type="h3")

                            v-flex.text-xs-right.mb-2(xs6)

                                // Close Modal window
                                button-icon(:action="resetEmail" color="white" icon="close")

                        v-layout(raw wrap)
                            v-flex(xs12)

                                // Email Subject field
                                v-text-field(
                                    :error-messages="errors.collect('subject')"
                                    :data-vv-as="$t('fields.subject')"
                                    :label="$t('fields.subject')"
                                    name="subject"
                                    v-model="model.subject"
                                    v-validate="'required|min:2|max:100'"
                                    outline
                                )

                                // Email Title field
                                v-text-field(
                                    :error-messages="errors.collect('title')"
                                    :data-vv-as="$t('fields.title')"
                                    :label="$t('fields.title')"
                                    name="title"
                                    v-model="model.title"
                                    v-validate="'required|min:2|max:100'"
                                    outline
                                )

                                // Email Body text-area
                                froala(
                                    v-model="model.message"
                                    :tag="'textarea'"
                                    :config="config"
                                )

                                div.bodyError(v-if="bodyError") Body field is required and minimum 2 characters

                        v-layout(raw wrap)
                            v-flex(xs12)

                                // Horizontal line
                                separator-component

                                div.controls
                                    div

                                        // Cancel button
                                        button-component.ml-0(
                                            :action="resetEmail"
                                            :isLoading="isLoading"
                                            :disabled="isLoading"
                                            color="grey"
                                            large
                                            outline
                                        ) {{ $t('defaultButtons.cancel') }}

                                    div

                                        // Submit button
                                        button-component.mr-0.submit(
                                            :action="createEmail"
                                            :isLoading="isLoading"
                                            :disabled="isLoading"
                                            color="white"
                                            large
                                        ) {{ submitButtonText }}
</template>

<script>
    import VueTypes from 'vue-types';
    import Button from '../Button';
    import ButtonIcon from '../ButtonIcon';
    import Separator from '../Separator';
    import Title from '../Title';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import '~plugins/froala';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonIcon,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        props: {
            emailIndex: VueTypes.number.def(-1),
            roteName: VueTypes.string.def('business')
        },
        data() {
            var self = this;

            return {
                bodyError: false,
                config: {
                    events: {
                        'froalaEditor.initialized': function() {},
                        'image.beforeUpload': async function(files) {
                            let editor = this;

                            if (files.length) {
                                let formData = new FormData();
                                formData.append('name', files[0].name);
                                formData.append('photo', files[0]);
                                const resp = await self.uploadImage(formData);
                                editor.image.showProgressBar();

                                if (resp.ok) {
                                    editor.image.insert(
                                        resp.data,
                                        null,
                                        null,
                                        editor.image.get()
                                    );
                                    editor.image.hideProgressBar();
                                }
                            }

                            return false;
                        }
                    },
                    toolbarButtons: {
                        moreText: {
                            buttons: [
                                'bold',
                                'italic',
                                'fontSize',
                                'underline',
                                'strikeThrough',
                                'textColor',
                                'backgroundColor',
                                'subscript',
                                'superscript',
                                'fontFamily',
                                'inlineClass',
                                'inlineStyle'
                            ]
                        },
                        moreParagraph: {
                            buttons: [
                                'alignLeft',
                                'alignCenter',
                                'formatOLSimple',
                                'alignRight',
                                'alignJustify',
                                'formatOL',
                                'formatUL',
                                'paragraphFormat',
                                'paragraphStyle',
                                'lineHeight',
                                'outdent',
                                'indent',
                                'quote'
                            ]
                        },
                        moreRich: {
                            buttons: [
                                'insertLink',
                                'insertImage',
                                'insertTable',
                                'emoticons',
                                'fontAwesome',
                                'specialCharacters',
                                'embedly',
                                'insertHR'
                            ]
                        },
                        moreMisc: {
                            buttons: ['undo', 'redo', 'fullscreen']
                        },
                        moreMisc2: {
                            buttons: ['clearFormatting', 'selectAll', 'html']
                        }
                    },
                    toolbarVisibleWithoutSelection: false,
                    imageMove: true,
                    imageTextNear: true,
                    quickInsertEnabled: false,
                    heightMax: 500,
                    heightMin: 300,
                    zIndex: 2501,
                    key:
                        'aLF3c1B8B7C4C2F2F2C-7gmokdhdrH-8ekB-16uD1qG-10yiB3B9B6A5C2C4F4H3A2H3=='
                }
            };
        },
        computed: {
            ...mapFields('emails', {
                model: 'email',
                showModal: 'showModal'
            }),
            ...mapGetters('emails', ['isLoading']),

            /**
             * Create email button text
             * @return {string}
             */
            createEmailButtonText() {
                return this.isMobile
                    ? this.$t('programs.create.addEmailButtonMobile')
                    : this.$t('programs.create.addEmailButton');
            },

            /**
             * Check screen resolution.
             * @returns {boolean}
             */
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },

            /**
             * Title text
             * @return {string}
             */
            title() {
                return this.emailIndex
                    ? this.$t('programs.email.createTitle')
                    : this.$t('programs.email.editTitle');
            },

            /**
             * Submit button text
             *  @returns {string}
             */
            submitButtonText() {
                return this.emailIndex
                    ? this.$t('defaultButtons.save')
                    : this.$t('defaultButtons.update');
            }
        },
        beforeMount() {
            if (this.emailIndex >= 0) {
                return this.setEmail(this.index);
            }
        },
        methods: {
            ...mapActions('emails', [
                'addEmail',
                'setEmail',
                'resetEmail',
                'triggerModal',
                'uploadImage'
            ]),

            /**
             * Remove html from variable
             * @param html
             * @returns {*}
             */
            htmlToText(html) {
                return html.replace(/<[^>]*>?/gm, '');
            },

            async createEmail() {
                // Validate all fields and check in no errors
                const validation = await this.$validator.validateAll();

                if (this.htmlToText(this.model.message).length < 2) {
                    this.bodyError = true;
                    return;
                }

                if (!validation) return;

                if (this.bodyError) {
                    this.bodyError = false;
                }

                // Call store action Create Business account
                this.addEmail(this.roteName);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'

    .dialogWrapper
        background: $theme.primary

    .bodyError
        padding-left: 20px
        color: $theme.error
        font-size: 12px
        margin-top: 3px

    >>>
        .fr-popup .fr-input-line input[type="text"],
        .fr-popup .fr-input-line textarea,
        .fr-element
            color: #000000 !important
            caret-color: #000000 !important
</style>
